import { Directive, Input, OnChanges, ViewContainerRef } from '@angular/core';
import { TableColumn } from '../models';

@Directive({ selector: '[vsTableCell]', standalone: false })
export class CellDirective implements OnChanges {
  @Input() column?: TableColumn<unknown>;
  @Input() item?: unknown;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnChanges() {
    this.viewContainerRef.clear();

    if (this.column && this.item) {
      const component = this.viewContainerRef.createComponent(this.column.component, {
        projectableNodes: [[document.createTextNode('')]],
      });

      component.instance._item = this.item;
      component.instance._data = this.column.data;
      component.instance._config = this.column.config;
      // PropertyListener may finish on a microtask; ensure the cell view (e.g. edit pencil) paints.
      queueMicrotask(() => {
        if (!component.hostView.destroyed) {
          component.changeDetectorRef.detectChanges();
        }
      });
    }
  }
}
